/**
 * @typedef {import('./SettingsComponent').Props} Props
 * @typedef {import('./SettingsComponent').State} State
 */
import { translate } from '../Internationalization';
import { withAuth } from '../../shared/AuthProvider';
import { withSubscriptionService } from '../../service-container';
import ChangePasswordCard from './ChangePasswordCard';
import ChangeUserEmailCard from './ChangeUserEmailCard';
import EditAdministratorDetailsCard from './EditAdministratorDetailsCard';
import EditAgentDetailsCard from './EditAgentDetailsCard';
import EditHomeownerDetailsCard from './EditHomeownerDetailsCard';
import React from 'react';
import RoleGate from '../shared/RoleGate';

/** @extends {React.Component<Props, State>} */
class Settings extends React.Component {
	/** @returns {JSX.Element} */
	// eslint-disable-next-line class-methods-use-this
	render() {
		return (
			<section className="app-container">
				<h1 className="hl-ms-6 mt-10 mb-6">
					{translate('settings.title')}
				</h1>

				{/* @ts-ignore -- Service container issue */}
				<RoleGate allowedRoles={['admin', 'manager', 'owner']}>
					<section className="mb-10">
						<EditAdministratorDetailsCard />
					</section>
				</RoleGate>

				{/* @ts-ignore -- Service container issue */}
				<RoleGate allowedRoles={['agent']}>
					<section className="mb-10">
						<EditAgentDetailsCard />
					</section>
				</RoleGate>

				{/* @ts-ignore -- Service container issue */}
				<RoleGate allowedRoles={['homeowner']}>
					<section className="mb-10">
						<EditHomeownerDetailsCard />
					</section>
				</RoleGate>

				<section className="mb-10">
					<ChangeUserEmailCard />
				</section>

				<section className="mb-10">
					<ChangePasswordCard />
				</section>
			</section>
		);
	}
}

// @ts-ignore
export default withSubscriptionService(withAuth(Settings));
